import { render, staticRenderFns } from "./fccLogs.vue?vue&type=template&id=0201bba6"
import script from "./fccLogs.vue?vue&type=script&lang=js"
export * from "./fccLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports